import { actions } from "./Reducer";

/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingArtisanProductAction = (body) => ({
  type: actions.UPDATE_PENDING_ARTISAN_PRODUCT,
  payload: body,
});

// Plural
export const getPendingArtisanProductsAction = (body) => ({
  type: actions.GET_PENDING_ARTISAN_PRODUCTS,
  payload: body,
});


/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const updatePendingArtisanProductSuccessAction = (product) => ({
  type: actions.UPDATE_PENDING_ARTISAN_PRODUCT_SUCCESS,
  payload: product,
});

// Plural
export const getPendingArtisanProductsSuccessAction = (products) => ({
  type: actions.GET_PENDING_ARTISAN_PRODUCTS_SUCCESS,
  payload: products,
});

export const getSinglePendingArtisanProductAction = (id) => ({
  type: actions.GET_SINGLE_PENDING_ARTISAN_PRODUCT,
  payload: id 
})

export const deleteSinglePendingArtisanProdcutAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_ARTISAN_PRODUCT,
  payload: id
})

export const moderateCreateSinglePendingArtisanProductAction = (id, mode) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT,
  payload: id,
  mode
})
/**
 * Misc
 */

export const setPendingArtisanProductsIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_ARTISAN_PRODUCTS_IS_LOADING,
  payload: isLoading,
});

export const setPendingArtisanProductsCountAction = (count) => ({
  type: actions.SET_PENDING_ARTISAN_PRODUCTS_COUNT,
  payload: count,
});

export const getSinglePendingArtisanProductSuccessAction = (product) => ({
  type: actions.GET_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS,
  payload: product
})

export const deleteSinglePendingArtisanProductSuccessAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS,
  payload: id
})

export const moderateCreateSinglePendingArtisanProductSuccessAction = (id) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT_SUCCESS,
  payload: id
})